import {
    ESTACIO_INICIALITZAR,
    ESTACIO_DONAR_DE_BAIXA_EN_CURS,
    ESTACIO_DONAR_DE_BAIXA_FINALITZADA
} from '../../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioDonarDeBaixaEstacioEnCurs = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_DONAR_DE_BAIXA_FINALITZADA:
            return false;

        case ESTACIO_DONAR_DE_BAIXA_EN_CURS:
            return true;

        default:
            return state;
    }
};

export default peticioDonarDeBaixaEstacioEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/estacio/peticioDonarDeBaixaEstacioEnCurs.js